<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import NextButton from 'dashboard/components-next/button/Button.vue';
import CreateInvoiceModal from 'dashboard/components/widgets/conversation/invoices/CreateInvoiceModal.vue';

const props = defineProps({
  conversationId: {
    type: Number,
    default: 0,
  },
  pinned: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['availability']);

const store = useStore();
const { isCloudFeatureEnabled } = useAccount();
const appIntegrations = useMapGetter('integrations/getAppIntegrations');

const isKhaltiConnected = computed(() =>
  appIntegrations.value.some(
    integration => integration.id === 'khalti' && !!integration.hooks.length
  )
);

const showButton = computed(
  () => isCloudFeatureEnabled(FEATURE_FLAGS.PAYMENTS) && isKhaltiConnected.value
);

const showModal = ref(false);

const closeModal = () => {
  showModal.value = false;
};

onMounted(() => {
  if (!appIntegrations.value.length) {
    store.dispatch('integrations/get');
  }
});

// The composer toolbar lists this tool in its "More tools" menu, so it needs to
// know whether the integration is set up.
watch(showButton, isAvailable => emit('availability', isAvailable), {
  immediate: true,
});

defineExpose({
  trigger: () => {
    showModal.value = true;
  },
});
</script>

<template>
  <NextButton
    v-if="showButton"
    v-show="pinned"
    v-tooltip.top-end="$t('INVOICES.REQUEST_BUTTON.TOOLTIP')"
    icon="i-ph-receipt"
    slate
    faded
    sm
    @click="showModal = true"
  />
  <CreateInvoiceModal
    v-if="showModal"
    :conversation-id="props.conversationId"
    @close="closeModal"
  />
</template>
